import React from "react";
import {
  FaRegCommentDots,
  FaFileContract,
  FaRss,
  FaChartPie,
  FaRegEdit,
} from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as RiIcons from "react-icons/ri";
import * as FaIcons from "react-icons/fa";
import * as BsIcons from "react-icons/bs";
import * as GoIcons from "react-icons/go";
import * as MdIcons from "react-icons/md";
import * as ImIcons from "react-icons/im";
import * as BiIcons from "react-icons/bi";
import { IoClipboard } from "react-icons/io5";
import { HiOutlineUsers } from "react-icons/hi";
import { BsCashStack } from "react-icons/bs";
import { FcDepartment } from "react-icons/fc";
import { FiMonitor, FiSettings } from "react-icons/fi";
import { PATH } from "../../config";
import { IMAGES } from "../../assets";
import { GiBassetHoundHead, GiExpense, GiReceiveMoney } from "react-icons/gi";
const HRM_PATH = "https://hrm.visioncollab.com/app";
const VC_TRACKER_PATH = "https://tracker.visioncollab.com";
const FMS_PATH = "https://fms.visioncollab.com";
export const AdminSidebar = [
  // Dashboards
  // {
  //   title: "dashboards",
  //   image: IMAGES.APPLOGO,
  //   iconClosed: <BsIcons.BsArrowLeftShort />,
  //   iconOpened: <BsIcons.BsArrowDownShort />,
  //   path: PATH.DASHBOARD.replace(":type", "ceo"),
  // },
  // PMS List
  {
    title: "project management",
    image: IMAGES.APPLOGO,
    iconClosed: <BsIcons.BsArrowLeftShort />,
    iconOpened: <BsIcons.BsArrowDownShort />,
    path: "#",
    subNav: [
      {
        title: "Dashboard",
        path: PATH.DASHBOARD.replace(":type", "ceo"),
        icon: <AiIcons.AiOutlineDashboard />,
      },
      {
        title: "Projects",
        path: PATH.PROJECTS,
        icon: <RiIcons.RiProjectorFill />,
      },
      {
        title: "Workload",
        path: PATH.WORKLOAD,
        icon: <FaIcons.FaBalanceScale />,
      },
      // {
      //   title: "My Work",
      //   path: PATH.MYWORK,
      //   icon: <AiIcons.AiOutlineCheckCircle />,
      // },
      {
        // title: "Todo",
        title: "Day Planner",
        path: PATH.TODO,
        icon: <BsIcons.BsListUl />,
      },
      {
        title: "Video Call",
        path: PATH.VIDEOLINKS,
        icon: <BsIcons.BsCameraVideo />,
      },
      {
        title: "Team Scheduler",
        path: PATH.TEAMSCHEDULER,
        icon: <GoIcons.GoDash />,
      },
      // {
      //   title: "Files",
      //   path: PATH.REPORTFILES,
      //   icon: <ImIcons.ImFilesEmpty />,
      // },
      // {
      //   title: "Reports",
      //   icon: <AiIcons.AiFillFileText />,
      //   iconClosed: <BsIcons.BsArrowLeftShort />,
      //   iconOpened: <BsIcons.BsArrowDownShort />,
      //   subNav: [
      //     {
      //       title: "Files",
      //       path: PATH.REPORTFILES,
      //       icon: <ImIcons.ImFilesEmpty />,
      //     },
      //   ],
      // },
      {
        title: "Human Resource",
        icon: <AiIcons.AiOutlineHome />,
        iconClosed: <BsIcons.BsArrowLeftShort />,
        iconOpened: <BsIcons.BsArrowDownShort />,
        path: "#",
        subNav: [
          {
            title: "Employees",
            path: PATH.EMPLOYEE,
            icon: <BsIcons.BsPeople />,
          },
          {
            title: "Assets",
            path: PATH.ASSETS,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Assets Allocation",
            path: PATH.ASSETSALLOCATION,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Daily Attendence",
            path: PATH.DAILYATTENDANCE,
            icon: <AiIcons.AiFillCheckSquare />,
          },
          {
            title: "Attendence",
            path: PATH.ATTENDANCE,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Leave Request",
            path: PATH.LEAVEREQUEST,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Users",
            path: PATH.USERLIST,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Departments",
            path: PATH.DEPARTMENTS,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Late Coming",
            path: PATH.LATECOMING,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Teams",
            path: PATH.TEAMS,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Suggestions",
            path: PATH.SUGGESTIONS,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Holidays",
            path: PATH.HOLIDAYS,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Events",
            path: PATH.EVENT,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "File",
            path: PATH.FILES,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "File Category",
            path: PATH.FILE_CATEGORY,
            icon: <GoIcons.GoDash />,
          },
        ],
      },
      {
        title: "Finance",
        icon: <FaIcons.FaHandHoldingUsd />,
        iconClosed: <BsIcons.BsArrowLeftShort />,
        iconOpened: <BsIcons.BsArrowDownShort />,
        subNav: [
          {
            title: "Dashboard",
            path: PATH.FINANCE_DASHBOARD,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Billable Hours",
            path: PATH.BILLABLEHOURS,
            icon: <GoIcons.GoDash />,
            iconClosed: <BsIcons.BsArrowLeftShort />,
            iconOpened: <BsIcons.BsArrowDownShort />,
          },
          {
            title: "Create Invoice",
            path: PATH.NEWINVOICE,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Invoices",
            path: PATH.INVOICELIST,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Income",
            path: PATH.INCOME,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Provident Fund",
            path: PATH.PROVIDENT_FUND,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Expense",
            path: PATH.EXPENSE,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Salaries",
            path: PATH.SALARY,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Loans",
            path: PATH.LOANS,
            icon: <GoIcons.GoDash />,
          },
          {
            title: "Cash Category",
            path: PATH.CASHCATEGORY,
            icon: <GoIcons.GoDash />,
          },
        ],
      },
      {
        title: "Settings",
        icon: <MdIcons.MdSettings />,
        iconClosed: <BsIcons.BsArrowLeftShort />,
        iconOpened: <BsIcons.BsArrowDownShort />,
        subNav: [
          {
            title: "Trash",
            path: PATH.TRASH,
            icon: <BsIcons.BsTrashFill />,
          },
          {
            title: "User Role",
            path: PATH.USER_ROLES,
            icon: <FaIcons.FaUserAlt />,
          },
          {
            title: "Manage Menus",
            path: PATH.MANAGEMENU,
            icon: <BiIcons.BiFoodMenu />,
          },
          {
            title: "Assign Role Based Menus",
            path: PATH.ROLEBASEDMENUS,
            icon: <FaIcons.FaUserAlt />,
          },
          {
            title: "Organizations",
            path: PATH.ORGANIZATION,
            icon: <GoIcons.GoOrganization />,
          },
          {
            title: "New User",
            path: PATH.MANAGEUSER,
            icon: <FaIcons.FaUserAlt />,
          },
          {
            title: "Clients",
            path: PATH.CLIENTS,
            icon: <FaIcons.FaUserAlt />,
          },
          {
            title: "Project Settings",
            path: PATH.PROJECTSETTINGS,
            icon: <MdIcons.MdSettings />,
          },
        ],
      },
    ],
  },
  // HRM List
  {
    title: "Human Resources",
    image: IMAGES.APPLOGO,
    iconClosed: <BsIcons.BsArrowLeftShort />,
    iconOpened: <BsIcons.BsArrowDownShort />,
    path: "#",
    subNav: [
      {
        title: "Dashboard",
        path: `${HRM_PATH}/Dashboard`,
        icon: <AiIcons.AiOutlineDashboard />,
      },
      {
        title: "Hiring",
        path: `${HRM_PATH}/hiring`,
        icon: <HiOutlineUsers />,
      },
      {
        title: "Applicants",
        path: `${HRM_PATH}/applicants`,
        icon: <HiOutlineUsers />,
      },
      {
        title: "HIRING",
        icon: <AiIcons.AiOutlineHome />,
        iconClosed: <BsIcons.BsArrowLeftShort />,
        iconOpened: <BsIcons.BsArrowDownShort />,
        path: "#",
        subNav: [
          {
            title: "Recruitment",
            icon: <AiIcons.AiOutlineHome />,
            iconClosed: <BsIcons.BsArrowLeftShort />,
            iconOpened: <BsIcons.BsArrowDownShort />,
            path: "#",
            subNav: [
              {
                title: "Recruitment Dashboard",
                path: `${HRM_PATH}/recruitment/Dashboard`,
                icon: <AiIcons.AiOutlineDashboard />,
              },
              {
                title: "Jobs",
                path: `${HRM_PATH}/recruitment/jobs/listing`,
                icon: <FaIcons.FaUserTie />,
              },
              {
                title: "Candidates",
                path: `${HRM_PATH}/recruitment/candidates/listing`,
                icon: <HiOutlineUsers />,
              },
            ],
          },
          {
            title: "Employee",
            path: `${HRM_PATH}/people`,
            icon: <FaIcons.FaUsers />,
          },
          {
            title: "My Info",
            path: `${HRM_PATH}/myInfo`,
            icon: <ImIcons.ImInfo />,
          },
          {
            title: "Assets",
            path: `${HRM_PATH}/assets`,
            icon: <GiBassetHoundHead />,
          },
        ],
      },
      {
        title: "ATTENDANCE",
        icon: <HiOutlineUsers />,
        iconClosed: <BsIcons.BsArrowLeftShort />,
        iconOpened: <BsIcons.BsArrowDownShort />,
        path: "#",
        subNav: [
          {
            title: "Attendance",
            icon: <HiOutlineUsers />,
            iconClosed: <BsIcons.BsArrowLeftShort />,
            iconOpened: <BsIcons.BsArrowDownShort />,
            path: "#",
            subNav: [
              {
                title: "Attendance Dashboard",
                path: `${HRM_PATH}/attendance/AttendanceHistory/AttendanceDashboard`,
                icon: <AiIcons.AiOutlineDashboard />,
              },
              {
                title: "Daily Attendance",
                path: `${HRM_PATH}/attendance/AttendanceHistory/DailyAttendance`,
                icon: <HiOutlineUsers />,
              },
              {
                title: "Leave Request",
                path: `${HRM_PATH}/attendance/AttendanceHistory/LeaveRequest`,
                icon: <HiOutlineUsers />,
              },
            ],
          },
          {
            title: "Events",
            path: `${HRM_PATH}/events`,
            icon: <MdIcons.MdEventNote />,
          },
          {
            title: "Departments",
            path: `${HRM_PATH}/departments`,
            icon: <FcDepartment />,
          },
          {
            title: "Teams",
            path: `${HRM_PATH}/teams`,
            icon: <FaIcons.FaUsers />,
          },
        ],
      },
    ],
  },

  // // VC Tracker List
  {
    title: "Resource Tracking",
    image: IMAGES.APPLOGO,
    iconClosed: <BsIcons.BsArrowLeftShort />,
    iconOpened: <BsIcons.BsArrowDownShort />,
    path: "#",
    subNav: [
      {
        title: "Real Time Insights",
        path: `${VC_TRACKER_PATH}/Ceo/Dashboard`,
        icon: <AiIcons.AiOutlineDashboard />,
      },
      {
        title: "Employees",
        path: `${VC_TRACKER_PATH}/Admin/Employee`,
        icon: <FaIcons.FaUsers />,
      },
      {
        title: "Screen Shots",
        path: `${VC_TRACKER_PATH}/Admin/ScreenShots`,
        icon: <BsIcons.BsImage />,
      },
      {
        title: "Apps And Websites",
        path: `${VC_TRACKER_PATH}/Admin/TopAppsAndWebsites`,
        icon: <FiMonitor />,
      },
      {
        title: "Activities",
        path: `${VC_TRACKER_PATH}/Admin/Activities`,
        icon: <BsIcons.BsMenuButtonWideFill />,
      },
      {
        title: "Settings",
        path: `${VC_TRACKER_PATH}/Admin/Settings`,
        icon: <FiSettings />,
      },
    ],
  },
  // FMS List
  {
    title: "Financial System",
    image: IMAGES.APPLOGO,
    iconClosed: <BsIcons.BsArrowLeftShort />,
    iconOpened: <BsIcons.BsArrowDownShort />,
    path: "#",
    subNav: [
      {
        title: "Dashboard",
        path: `${FMS_PATH}/dashboard`,
        icon: <AiIcons.AiOutlineDashboard />,
      },
      {
        title: "Income",
        path: `${FMS_PATH}/income`,
        icon: <GiReceiveMoney />,
      },
      {
        title: "Expenses",
        path: `${FMS_PATH}/expense`,
        icon: <GiExpense />,
      },
      {
        title: "Pay Codes",
        path: `${FMS_PATH}/pay-code`,
        icon: <GiReceiveMoney />,
      },
      // {
      //   title: "Invoices",
      //   path: `${FMS_PATH}/invoices`,
      //   icon: <FaIcons.FaFileInvoice />,
      // },
      {
        title: "Loan",
        path: `${FMS_PATH}/loan`,
        icon: <GiReceiveMoney />,
      },
      {
        title: "Salaries",
        path: `${FMS_PATH}/salaries`,
        icon: <BsCashStack />,
      },
      {
        title: "Provident Fund",
        path: `${FMS_PATH}/providentfund`,
        icon: <GiReceiveMoney />,
      },
      {
        title: "Cash Category",
        path: `${FMS_PATH}/cashcategory`,
        icon: <BsCashStack />,
      },
      {
        title: "Billable Hours",
        path: `${FMS_PATH}/billablehours`,
        icon: <RiIcons.Ri24HoursFill />,
      },
      {
        title: "Monthly Employee Compensations",
        path: `${FMS_PATH}/monthlyemployeecompensation`,
        icon: <BsCashStack />,
      },
    ],
  },
  {
    title: "Payroll",
    image: IMAGES.APPLOGO,
    iconClosed: <BsIcons.BsArrowLeftShort />,
    iconOpened: <BsIcons.BsArrowDownShort />,
    path: "#",
    subNav: [
      // {
      //   title: "Dashboard",
      //   path: `${FMS_PATH}/dashboard`,
      //   icon: <AiIcons.AiOutlineDashboard />,
      // },
      // {
      //   title: "Income",
      //   path: `${FMS_PATH}/income`,
      //   icon: <GiReceiveMoney />,
      // },
      // {
      //   title: "Expenses",
      //   path: `${FMS_PATH}/expense`,
      //   icon: <GiExpense />,
      // },
      // {
      //   title: "Pay Codes",
      //   path: `${FMS_PATH}/pay-code`,
      //   icon: <GiReceiveMoney />,
      // },
      // {
      //   title: "Payroll",
      //   path: `${FMS_PATH}/pay-code`,
      //   icon: <GiReceiveMoney />,
      // },
      {
        title: "Invoices",
        path: `${FMS_PATH}/invoices`,
        icon: <FaIcons.FaFileInvoice />,
      },
      // {
      //   title: "Loan",
      //   path: `${FMS_PATH}/loan`,
      //   icon: <GiReceiveMoney />,
      // },
      // {
      //   title: "Salaries",
      //   path: `${FMS_PATH}/salaries`,
      //   icon: <BsCashStack />,
      // },
      // {
      //   title: "Provident Fund",
      //   path: `${FMS_PATH}/providentfund`,
      //   icon: <GiReceiveMoney />,
      // },
      // {
      //   title: "Cash Category",
      //   path: `${FMS_PATH}/cashcategory`,
      //   icon: <BsCashStack />,
      // },
      // {
      //   title: "Billable Hours",
      //   path: `${FMS_PATH}/billablehours`,
      //   icon: <RiIcons.Ri24HoursFill />,
      // },
      // {
      //   title: "Monthly Employee Compensations",
      //   path: `${FMS_PATH}/monthlyemployeecompensation`,
      //   icon: <BsCashStack />,
      // },
    ],
  },
  {
    title: "File Cloud",
    path: PATH.REPORTFILES,
    image: IMAGES.APPLOGO,
  },
  {
    title: "Pricing",
    path: PATH.PRICING,
    image: IMAGES.APPLOGO,
  },
];

export const EmpSidebar = [
  {
    title: "Dashboard",
    path: PATH.DASHBOARD.replace(":type", "ceo"),
    icon: <AiIcons.AiOutlineDashboard />,
  },
  {
    title: "Notice Board",
    path: PATH.NOTICEBOARD,
    icon: <IoClipboard />,
  },
  {
    title: "Stats",
    path: "#",
    icon: <ImIcons.ImStatsBars />,
  },
  {
    title: "Projects",
    path: PATH.PROJECTS,
    icon: <RiIcons.RiProjectorFill />,
  },
  {
    title: "Attendance",
    path: PATH.ATTENDANCE,
    icon: <AiIcons.AiFillCheckSquare />,
  },
  {
    title: "Day Planner",
    path: PATH.TODO,
    icon: <AiIcons.AiOutlineUnorderedList />,
  },
  {
    title: "Feedback",
    path: "#",
    icon: <FaRegCommentDots className="sidebar-icons" />,
    subNav: [
      {
        title: "Templates",
        path: PATH.TEMPLATE,
        icon: (
          <FaFileContract className="sidebar-sub-menu-icons menu-bg-color" />
        ),
      },
      {
        title: "Assign Feedback",
        path: PATH.FEEDBACKASSIGN,
        icon: <FaRss className="sidebar-sub-menu-icons menu-bg-color" />,
      },
      {
        title: "Feedback Review",
        path: PATH.FEEDBACKREVIEW,
        icon: <FaChartPie className="sidebar-sub-menu-icons menu-bg-color" />,
      },
      {
        title: "Give Feedback",
        path: PATH.GIVEFEEDBACK,
        icon: <FaRegEdit className="sidebar-sub-menu-icons menu-bg-color" />,
      },
    ],
  },
];
